export default __webpack_public_path__ + "static/media/unicons.257bdf01.ttf";